import React, { useEffect, useState } from 'react';
import api from '@common/utils/api';
import '@moncler/scss/components/embedded-video/component-embedded-video.scss';
const EmbeddedVideo = (props) => {
    const [componentData, setComponentData] = useState(null);
    useEffect(() => {
        var _a;
        let pageID = (_a = document.body.id) === null || _a === void 0 ? void 0 : _a.replace('page-', '');
        if (pageID) {
            api.getPageJson(pageID, true).then((data) => {
                var _a;
                let componentDataRes = (_a = data.regions[0].components) === null || _a === void 0 ? void 0 : _a.find((c) => c.id === props.uuid);
                setComponentData(componentDataRes === null || componentDataRes === void 0 ? void 0 : componentDataRes.data);
            });
        }
    }, []);
    // const embedYoutube = () => {
    //   return (
    //     <iframe
    //       src={`https://www.youtube-nocookie.com/embed/${componentData.youtubeID}?modestbranding=1&rel=0&color=white`}
    //       width="300"
    //       height="150"
    //       title={componentData.title}
    //       frameBorder="0"
    //       allowFullScreen
    //     ></iframe>
    //   );
    // };
    // const embedVimeo = () => {
    //   return <iframe src={`https://player.vimeo.com/video/${componentData.vimeoID}`} title={componentData.title} width="640" height="360" frameBorder="0" allowFullScreen></iframe>;
    // };
    // const videoIframe = () => {
    //   if (componentData.youtubeID) {
    //     return embedYoutube();
    //   } else if (componentData.vimeoID) {
    //     return embedVimeo();
    //   }
    // };
    const embedCode = () => {
        if (componentData.embed_html) {
            return React.createElement("div", { dangerouslySetInnerHTML: { __html: componentData.embed_html } });
        }
    };
    if (!componentData) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "embedded-video" },
        React.createElement("div", { className: "embedded-video__title-wrapper" },
            React.createElement("h2", { className: "embedded-video__title" }, componentData.title),
            React.createElement("p", { className: "embedded-video__subtitle" }, componentData.subtitle)),
        embedCode()));
};
export default EmbeddedVideo;
